import React from "react";
import Avatar from "react-avatar";
import { Col, Row } from "react-bootstrap";

import { useRouteContext } from "libs/contextLib";

import { LIVE, LIVE_RECORDED } from "constants/course-list-item";

import "./course-list-item.scss";

function CourseListItem(props) {
  const { navigate } = useRouteContext();

  function getCourseTags() {
    let tags = [];
    if (props.course.streamType === "mixed") {
      tags.push(LIVE_RECORDED);
    } else if (props.course.streamType === "live_only") tags.push(LIVE);

    if (props.course.remainingSubscriptions) {
      tags.push(props.course.remainingSubscriptions + " slots left");
    }

    return tags;
  }

  const courseTags = getCourseTags();
  return (
    <Row className="course-card mb-4 mx-1 p-2 bg-white rounded border">
      <Col xs={12} md={3} className="p-0 cover-image">
        <img
          alt="course-cover"
          src={props.course.imageUrls[0]}
          style={{
            objectFit: "cover",
          }}
          className="h-100 w-100 rounded"
        />
      </Col>
      <Col xs={12} md={9}>
        <Row className="justify-content-between align-items-center mt-2">
          <Col xs="auto" className="name">
            {props.course.name}
          </Col>
          {!courseTags ? null : (
            <Col xs="auto" className="tags">
              <Row>
                {courseTags.map((tag) => (
                  <Col key={tag} xs="auto" className="tag h2 rounded py-1 mx-1">
                    {tag}
                  </Col>
                ))}
              </Row>
            </Col>
          )}
        </Row>
        <Row className="justify-content-between">
          <Col xs={9}>
            {props.for === "teacher" ? null : (
              <div>
                <span className="preposition"> by </span>
                <span className="teacher-name">
                  {props.course.teacher.firstName +
                    " " +
                    props.course.teacher.lastName}
                </span>
              </div>
            )}
            {props.course.schedule && props.course.schedule.length ? (
              <div className="mt-2">
                <span className="schedule border rounded p-1">
                  {props.course.schedule}
                </span>
              </div>
            ) : null}
            {props.course.description && props.course.description.length ? (
              <div className="description text-muted mt-2">
                {props.course.description}
              </div>
            ) : null}
          </Col>
          {props.for === "teacher" ? null : (
            <Col xs={3} className="pr-2 text-right">
              <Avatar
                name={
                  props.course.teacher.firstName +
                  " " +
                  (props.course.teacher.lastName || "")
                }
                src={props.course.teacher.profileImage}
                round={true}
                size={80}
                className="teacher-profile-image"
              />
            </Col>
          )}
        </Row>
        <div className="border-top mx-2 mt-3 mb-2"></div>
        <Row className="justify-content-around mt-2">
          <Col
            as="button"
            xs={10}
            sm="auto"
            className="text-center mb-2 course-detail-button border-0 px-4 rounded py-2"
            onClick={() => navigate(`course/${props.course.id}/classes`)}
          >
            Classes
          </Col>
          <Col
            as="button"
            xs={10}
            sm="auto"
            className="text-center mb-2 course-detail-button border-0 px-4 rounded py-2"
            onClick={() => navigate(`course/${props.course.id}/details`)}
          >
            Details
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
export default CourseListItem;
